<!-- sidebar left start-->
<div class="sidebar-left sidebar-offcanvas overflow-auto h-100 " role="navigation">
  <div class="sidebar-left-info">
    <!--sidebar nav start-->
    <ul class="side-navigation nav flex-column sticky-top pl-0 pt-5 mt-3">
      <li routerLinkActive="active" *ngFor="let menu of menus"
        [ngClass]="{'menu-list':menu.childrens,'nav-active':menu.open}">
        <a *ngIf="menu.link && !menu.disabled" [routerLink]="[menu.link]"><i [ngClass]="menu.icons"></i>
          <span class="hidden-menu">{{menu.title}}</span>
        </a>
        <a *ngIf="menu.link && menu.disabled" href="javascript:void(0);" class="text-muted cursor-not-allowed"><i
            [ngClass]="menu.icons"></i>
          <span class="hidden-menu">{{menu.title}}</span>
        </a>
        <a *ngIf="!menu.link" href="javascript:void(0);" (click)="menu.open=!menu.open"><i [ngClass]="menu.icons"></i>
          <span class="hidden-menu">{{menu.title}}</span>
        </a>
        <ul class="child-list" *ngIf="menu.open && menu.childrens && menu.childrens.length>0">
          <li *ngFor="let children of menu.childrens">
            <!-- <a [routerLink]="[children.link]">{{children.title}}</a> -->
            <a [routerLink]="[children.link]" *ngIf="!children.disabled">{{children.title}}</a>
            <a href="javascript:void(0);" *ngIf="children.disabled"
              class="text-muted cursor-not-allowed">{{children.title}}</a>
          </li>
        </ul>
      </li>
    </ul>
    <!--sidebar nav end-->
  </div>
</div><!-- sidebar left end-->